
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.125 1.25h-.75V0h-1.25v1.25h-8.25V0h-1.25v1.25h-.75A1.877 1.877 0 000 3.125v11C0 15.159.841 16 1.875 16h12.25A1.877 1.877 0 0016 14.125v-11a1.877 1.877 0 00-1.875-1.875zm.625 12.875c0 .345-.28.625-.625.625H1.875a.626.626 0 01-.625-.625v-8.25h13.5v8.25zm0-9.5H1.25v-1.5c0-.345.28-.625.625-.625h.75v1.25h1.25V2.5h8.25v1.25h1.25V2.5h.75c.345 0 .625.28.625.625v1.5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M3.625 7.188h-1.25v1.25h1.25v-1.25zM6.125 7.188h-1.25v1.25h1.25v-1.25zM8.625 7.188h-1.25v1.25h1.25v-1.25zM11.125 7.188h-1.25v1.25h1.25v-1.25zM13.625 7.188h-1.25v1.25h1.25v-1.25zM3.625 9.688h-1.25v1.25h1.25v-1.25zM6.125 9.688h-1.25v1.25h1.25v-1.25zM8.625 9.688h-1.25v1.25h1.25v-1.25zM11.125 9.688h-1.25v1.25h1.25v-1.25zM13.625 9.688h-1.25v1.25h1.25v-1.25zM3.625 12.188h-1.25v1.25h1.25v-1.25zM6.125 12.188h-1.25v1.25h1.25v-1.25zM8.625 12.188h-1.25v1.25h1.25v-1.25zM11.125 12.188h-1.25v1.25h1.25v-1.25z","fill":"currentColor"}})])
          )
        }
      }
    